import { makeStyles } from '@material-ui/styles'
import DazzedParagraph14 from 'components/common/text/DazzedParagraph14'
import React from 'react'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(() => ({
  container: {
    background: 'rgba(255, 255, 255, 0.15)',
    border: '0.5px solid rgba(255, 255, 255, 0.5)',
    padding: 24,
    marginBottom: 20
  }
}))

const CreditCardDisclaimer = () => {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <div className={classes.container}>
      <DazzedParagraph14 color="var(--text-color-1)">{t('pages.billingInfo.disclaimer.text')}</DazzedParagraph14>
    </div>
  )
}

export default CreditCardDisclaimer
